import React from 'react';

/**
 * 🎨 COMPONENTE CARD - Reutilizável
 * 
 * Card/container flexível e reutilizável para agrupar conteúdo.
 * Usa TailwindCSS para estilização.
 * 
 * @param {ReactNode} children - Conteúdo do card
 * @param {string} className - Classes CSS adicionais
 * @param {boolean} hover - Se deve ter efeito hover
 * @param {string} padding - Tamanho do padding: 'sm' | 'md' | 'lg' | 'none'
 * @param {boolean} shadow - Se deve ter sombra
 * @param {function} onClick - Função chamada ao clicar (transforma em botão)
 * @param {object} props - Outras props do HTML div
 */
const Card = ({ 
  children, 
  className = '', 
  hover = false,
  padding = 'md',
  shadow = true,
  onClick,
  ...props 
}) => {
  // Padding sizes
  const paddings = {
    none: '',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
  };
  
  // Classes base
  const baseClasses = `
    bg-white 
    rounded-lg 
    border 
    border-gray-200
  `;
  
  // Classes de sombra
  const shadowClasses = shadow
    ? 'shadow-md hover:shadow-lg'
    : '';
  
  // Classes de hover
  const hoverClasses = hover || onClick
    ? 'transition-shadow duration-200 cursor-pointer hover:-translate-y-0.5'
    : '';
  
  // Classes de cursor se for clicável
  const cursorClasses = onClick ? 'cursor-pointer' : '';
  
  const cardClasses = `
    ${baseClasses}
    ${paddings[padding]}
    ${shadowClasses}
    ${hoverClasses}
    ${cursorClasses}
    ${className}
  `.trim().replace(/\s+/g, ' ');
  
  return (
    <div
      className={cardClasses}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e);
        }
      } : undefined}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;

